import { videos } from "@/mocks/videos";
import type { Video } from "@/types/video";

export const allVideos: Video[] = videos;

export const categoryIds = ["电影", "电视剧", "短片"];

export function getVideoById(id: string): Video | undefined {
  return allVideos.find((v) => v.id === id);
}

export function getVideosByCategory(category: string): Video[] {
  return allVideos.filter((v) => v.category === category);
}

export function getFeatured(): Video[] {
  return allVideos.filter((v) => v.featured);
}

export function getLatest(limit?: number): Video[] {
  const list = [...allVideos]
    .filter((v) => v.latest)
    .sort((a, b) => (a.updateDate < b.updateDate ? 1 : -1));
  return typeof limit === "number" ? list.slice(0, limit) : list;
}

export function getHot(limit?: number): Video[] {
  const list = [...allVideos]
    .filter((v) => v.hot)
    .sort((a, b) => b.rating - a.rating);
  return typeof limit === "number" ? list.slice(0, limit) : list;
}

export function getRelated(video: Video, limit = 4): Video[] {
  return allVideos
    .filter((v) => v.id !== video.id)
    .map((v) => {
      let score = 0;
      if (v.category === video.category) score += 3;
      score += v.genres.filter((g) => video.genres.includes(g)).length * 2;
      if (v.region === video.region) score += 1;
      return { v, score };
    })
    .sort((a, b) => b.score - a.score)
    .slice(0, limit)
    .map((item) => item.v);
}

export function searchVideos(keyword: string): Video[] {
  const kw = keyword.trim().toLowerCase();
  if (!kw) return [];
  return allVideos.filter((v) => {
    return (
      v.title.toLowerCase().includes(kw) ||
      v.category.toLowerCase().includes(kw) ||
      v.region.toLowerCase().includes(kw) ||
      v.genres.some((g) => g.toLowerCase().includes(kw)) ||
      (v.director && v.director.toLowerCase().includes(kw)) ||
      v.cast.some((c) => c.toLowerCase().includes(kw)) ||
      v.summary.toLowerCase().includes(kw)
    );
  });
}

export function getGenres(category?: string): string[] {
  const source = category
    ? allVideos.filter((v) => v.category === category)
    : allVideos;
  const set = new Set<string>();
  source.forEach((v) => v.genres.forEach((g) => set.add(g)));
  return Array.from(set);
}

export function getRegions(category?: string): string[] {
  const source = category
    ? allVideos.filter((v) => v.category === category)
    : allVideos;
  const set = new Set<string>();
  source.forEach((v) => set.add(v.region));
  return Array.from(set);
}

export function getYears(category?: string): number[] {
  const source = category
    ? allVideos.filter((v) => v.category === category)
    : allVideos;
  const set = new Set<number>();
  source.forEach((v) => set.add(v.year));
  return Array.from(set).sort((a, b) => b - a);
}

export interface FilterOptions {
  category?: string;
  genre?: string;
  region?: string;
  year?: string;
  sort?: string;
}

export function filterVideos({
  category,
  genre,
  region,
  year,
  sort,
}: FilterOptions): Video[] {
  let list = allVideos;
  if (category) list = list.filter((v) => v.category === category);
  if (genre) list = list.filter((v) => v.genres.includes(genre));
  if (region) list = list.filter((v) => v.region === region);
  if (year) list = list.filter((v) => String(v.year) === year);

  const sorted = [...list];
  if (sort === "hot") {
    sorted.sort((a, b) => b.rating - a.rating);
  } else {
    sorted.sort((a, b) => (a.updateDate < b.updateDate ? 1 : -1));
  }
  return sorted;
}